import { createFetchEntityAction, createSaveEntityAction } from '../generic/entityAction';

export const PRESENCE_FACTS_LIST = 'PRESENCE_FACTS_LIST';
export const FOOD_REPORT_DIMENSIONS = 'FOOD_REPORT_DIMENSIONS';

export default {
    fetchAll: createFetchEntityAction(groupId => `/api/presence-facts?groupId=${groupId}`, PRESENCE_FACTS_LIST),
    saveAll: createSaveEntityAction(() => '/api/presence-facts', PRESENCE_FACTS_LIST),
    fetchDimensions: createFetchEntityAction(locationId => `/api/presence-facts/${locationId}/dimensions`, FOOD_REPORT_DIMENSIONS),
};